import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import ExpiryReasonTab from "../../../containers/expiry-reasons-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { getExpiryReasons } from "../../../services/expiryReasonService";
import { showError } from "../../../services/utilities/ServiceError";
import { toast } from "react-toastify";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const ExpiryReason: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));
    const { translate } = useLocale();

    useEffect(() => {
        buildCategories();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <ExpiryReasonTab></ExpiryReasonTab>
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const buildCategories = async () => {
        try{
            setBusy(true);
            const expiryReasons = await getExpiryReasons();
            setCategories([{
                displayName: translate.byKey(TranslationKeys.expiryReasons),
                heading: translate.byKey(TranslationKeys.expiryReasons),
                value: "",
                id: 0,
                count: expiryReasons.pagination.totalCount
            }]);
            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            { value: '/access-control/modules', displayName: translate.byKey(TranslationKeys.modules) },
                            { value: "/access-control/module/expiry-reasons", displayName: translate.byKey(TranslationKeys.expiryReasons) }]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        setSelectedTab={setSelected}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-row justify-end button-cluster">
                            <Restricted to={`add.${routeName}.element`}>
                                <Link to={{ pathname: "/access-control/module/expiry-reason/" }}>
                                    <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg">
                                        <img src={plusIcon} className="px-2 w-8 py-1" alt="" />
                                        <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                    </button>
                                </Link>
                            </Restricted>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default ExpiryReason;
